import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept' : 'application/json',
  }
});

console.log("API Base URL:", process.env.REACT_APP_API_URL);

axiosInstance.interceptors.request.use((config) => {
  const language = localStorage.getItem("i18nextLng") || "ar"; 
  config.headers["Accept-Language"] = language;
  return config;
  
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log the request details
    console.log("Axios Request:", {
      url: config.url,
      method: config.method,
      headers: config.headers,
      data: config.data,
      params: config.params,
    });

    return config;
  },
  (error) => {
    console.error("Axios Request Error:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    console.log("Axios Response:", response);
    return response.data !== undefined ? response : { data: false }; // عدم إرجاع `undefined`
  },
  (error) => {
    console.error("Axios Response Error:", error);
    return Promise.reject(error.response?.data || error.message);
  }
);


export default axiosInstance;
